import { render, staticRenderFns } from "./WhPackUpdate.vue?vue&type=template&id=13df2ac0&lang=pug&"
import script from "./WhPackUpdate.vue?vue&type=script&lang=js&"
export * from "./WhPackUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WhPackUpdate.vue"
export default component.exports